export const enum ExportDialogs {
  Pdf = 'Generating PDF export',
  Csv = 'Generating CSV export',
}
